import { render, staticRenderFns } from "./brand-campaign-toll-free-verification.vue?vue&type=template&id=9f9c38b6&scoped=true&"
import script from "./brand-campaign-toll-free-verification.vue?vue&type=script&lang=js&"
export * from "./brand-campaign-toll-free-verification.vue?vue&type=script&lang=js&"
import style0 from "./brand-campaign-toll-free-verification.vue?vue&type=style&index=0&id=9f9c38b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9c38b6",
  null
  
)

export default component.exports